"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatStandardDisplay = formatStandardDisplay;
const decimal_display_1 = require("./decimal-display");
/**
 * Assembles the standard three-part display (Ostvarenje norme / Odstupanje / broj
 * normiranih minuta) used consistently across Dnevni unos, Dashboard, Analitika,
 * izveštaj radnika, Excel/print export (FORMULA_AND_CALCULATION_MAP.md §1.5,
 * CALCULATION_ENGINE_ARCHITECTURE.md §7). Performs no rounding of its own —
 * inputs must already be calculation-engine rounded decimal strings.
 */
function formatStandardDisplay(input) {
    return {
        performanceRatioLabel: (0, decimal_display_1.formatPerformanceRatioLabel)(input.performanceRatioPercent),
        deviationLabel: (0, decimal_display_1.formatDeviationPointsCompactLabel)(input.deviationPercent),
        normedMinutesLabel: (0, decimal_display_1.formatNormedMinutesLabel)(input.normedMinutes),
    };
}
//# sourceMappingURL=standard-display.js.map